
export function NavbarLogo() {

    return (
        <a href="/" >
            <img src="/navbar.png" alt="" width="160" height="40"/>
        </a>
    )

}